import type { ReactElement } from 'react';
import type { ExtensionListItem } from '@kirin/api-client/contracts/extensions';
import {
  VerifiedPublisherIcon,
  IDEBadge,
} from '@/components/shared/extensions';
import { Link } from 'react-router-dom';
import { RelativeTimeWithTooltip } from '@/components/shared/RelativeTimeWithTooltip';

interface CellProps {
  row: ExtensionListItem;
}

export function NameCell({ row }: CellProps) {
  return (
    <span className="font-medium block whitespace-normal break-words">
      {row.displayName ?? row.extensionName}
    </span>
  );
}

export function PublisherCell({ row }: CellProps) {
  return (
    <div className="flex items-center gap-1.5">
      <VerifiedPublisherIcon isVerified={row.isVerified} />
      <span className="text-muted-foreground">{row.publisher}</span>
    </div>
  );
}

export function IDECell({ row }: CellProps) {
  return <IDEBadge sources={row.sources} />;
}

export function FirstSeenCell({ row }: CellProps) {
  return <RelativeTimeWithTooltip date={row.firstSeenAt} />;
}

export function LastSeenCell({ row }: CellProps) {
  return <RelativeTimeWithTooltip date={row.lastSeenAt} />;
}

export function ScanResultLinkCell({ row }: CellProps): ReactElement | null {
  if (row.securitySummary == null) {
    return null;
  }

  const version = row.versions[0]?.version;
  const params = new URLSearchParams();
  if (version) {
    params.set('version', version);
  }
  const query = params.toString();

  return (
    <Link
      to={`/dashboard/inventory/extensions/${encodeURIComponent(row.extensionId)}/scan-result${query ? `?${query}` : ''}`}
      className="text-primary text-sm hover:underline"
    >
      View scan result →
    </Link>
  );
}
